export const AMOUNT_DIGITS_AFTER_DOT = 2;